<script lang="ts" setup generic="T extends string | number | symbol">
import AppSvgIcon from '../../appSvgIcon/AppSvgIcon.vue';
import type { AppSingleSelectOption } from '../models/single.model';

interface AppSingleSelectItem<T> {
  item: AppSingleSelectOption<T>;
  isSelected: boolean;
  wrap?: boolean;
}

const props = defineProps<AppSingleSelectItem<T>>();

interface AppSingleSelectItemEmits<T> {
  (eventName: 'select', value: AppSingleSelectOption<T>): void;
}

const emit = defineEmits<AppSingleSelectItemEmits<T>>();
</script>

<template>
  <div
    class="app-single-select-dropdown-item"
    :class="{
      selected: props.isSelected,
      wrap: props.wrap,
    }"
    @click="emit('select', props.item)"
  >
    <template v-if="props.item.icon">
      <AppSvgIcon :name="props.item.icon" size="18" />
      <span class="app-single-select-item-label">{{ props.item.label }}</span>
    </template>
    <template v-else>
      <span class="app-single-select-item-label">{{ props.item.label }}</span>
    </template>
  </div>
</template>

<style lang="scss" scoped>
@import '../../../styles/_media.scss';
@import '../../../styles/_fonts.scss';

.app-single-select-dropdown-item {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: var(--spacing-8);
  cursor: pointer;
  background-color: var(--color-white);
  color: var(--color-neutral-70);
  padding: var(--spacing-16);

  @include font-label-m-light;
  @include on-hover {
    background-color: var(--color-neutral-20);
    color: var(--color-neutral-70);
  }

  .app-single-select-item-label {
    white-space: nowrap;
  }

  &:first-of-type {
    border-top-left-radius: var(--border-radius-8);
    border-top-right-radius: var(--border-radius-8);
  }
  &:last-of-type {
    border-bottom-left-radius: var(--border-radius-8);
    border-bottom-right-radius: var(--border-radius-8);
  }

  &.selected {
    background: var(--color-neutral-70);
    color: var(--color-white);

    @include on-hover {
      background: var(--color-neutral-60);
      color: var(--color-white);
    }
  }
}
</style>
